import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import RouteHandler from "./components/RouteHandler";

ReactDOM.render(
  <React.StrictMode>
    <RouteHandler />
  </React.StrictMode>,
  document.getElementById("root")
);
